import React from "react";
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

function Header() {
  return (
    <header>
      <h2><EmojiObjectsIcon />NoteKeeper</h2>
    </header>
  );
}

export default Header;
